export default __webpack_public_path__ + "static/media/Rectangle-1.8b88efbd.png";